import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  clearField,
  getError,
  NumberInputTableFilter,
  SmartFormContainer,
} from '@shared';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-number-input-filter',
  templateUrl: './number-input-filter.component.html',
  styleUrls: ['./number-input-filter.component.scss'],
})
export class NumberInputFilterComponent extends SmartFormContainer implements OnInit, OnDestroy {
  readonly getError = getError;
  readonly clearField = clearField;
  @Input() config: NumberInputTableFilter;

  private numberInputSubscription: Subscription = null;

  get control(): FormControl {
    return this.form.get(this.controlName) as FormControl;
  }

  ngOnInit() {
    super.ngOnInit();
    this.initValueChangesSubscription();
  }

  private initValueChangesSubscription(): void {
    this.numberInputSubscription = this.control.valueChanges.pipe(
      filter(value => value === '' && value !== this.config.initialValue),
    )
      .subscribe((value) => this.control.patchValue(this.config.initialValue));
  }

  stopPropagation(event: MouseEvent): void {
    event.stopPropagation();
  }

  ngOnDestroy(): void {
    this.numberInputSubscription?.unsubscribe();
  }
}
